import React from 'react';
import { Box } from '@mui/material';
import { FORM_SECTION_STYLES } from '../../theme/constants';

/**
 * FormRow - A container for side-by-side form fields
 * 
 * Usage:
 * <FormRow>
 *   <FormField label="Frequency" required>
 *     <Select ... />
 *   </FormField>
 *   <FormField label="Time of Day" required>
 *     <Select ... />
 *   </FormField>
 *   <FormField label="Timezone" required>
 *     <Select ... />
 *   </FormField>
 * </FormRow>
 */
const FormRow = ({
  children,
  spacing = 2,
  sx = {},
}) => {
  return (
    <Box 
      sx={{ 
        ...FORM_SECTION_STYLES.fieldRow, 
        gap: spacing,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export default FormRow;
